import styled from 'styled-components';

const TitleMLStyled = styled.div`
  .title-style {
    color: ${(props) => props.theme.palette.black};
    font-size: ${(props) => (props.fontSize ? props.fontSize : '14px')};
    font-family: SourceHanSansCN;
    font-weight: 500;
    line-height: 1;
  }
`;
export default TitleMLStyled;
